class BirthstonePicker extends HTMLElement {
  constructor() {
    super();

    this.selectedImage = this.querySelector('.selected-image');
    this.imageModal = this.querySelector('.image-modal');
    this.closeButton = this.querySelector('.close');
    this.index = this.dataset.index;
    this.input = document.querySelector(`#select-birthstone-data-${this.index}`);


    this.handleEvents.bind(this)();

  }

  handleEvents() {
    this.selectedImage.addEventListener('click', this.openModal.bind(this));
    this.closeButton.addEventListener('click', this.closeModal.bind(this));
    this.imageModal.addEventListener('click', (e) => {
      if (e.target.tagName === 'IMG') {
        this.updateBirthstone(e.target);
      }
      this.dispatchUpdate();
    });
    
    const dateSelectedEvent = 'dateSelected-moon-phase-finder--' + this.index;
    document.addEventListener(dateSelectedEvent, async (e) => {
      const date = e.detail.date; // "20-1-2025"
      const month = Number(date.split('-')[1]);
      const targetImg = this.querySelector(`img[data-month-index="${month}"]`);
      this.updateBirthstone(targetImg);
    });
  }

  dispatchUpdate() {
    const event = new CustomEvent('calendar:updated', {
      detail: {
        element: this.input.value,
        index: this.index
      }
    });
    document.dispatchEvent(event);
  }

  updateInputValue(name, month) {
    this.input.value = `${month} | ${name}`;
  }

  updateBirthstone(targetImage) {
    const selectedImage = this.querySelector('.selected-image img'); // Dynamically fetch the updated element
    const birthstoneName = this.querySelector('.birthstone-name');
    const month = targetImage.dataset.month;
    const name = targetImage.dataset.name;

    this.updateInputValue(name, month);
    birthstoneName.textContent = `${name} | ${month}`;
    birthstoneName.classList.remove('default');

    selectedImage.src = targetImage.src; // Update the `src` dynamically
    selectedImage.alt = targetImage.alt; // Update the `alt` dynamically
    selectedImage.dataset.name = name; // Update the `dataset` dynamically
    selectedImage.dataset.month = month; // Update the `dataset` dynamically

    this.closeModal();
  }

  closeImageModals() {
    const imageModals = document.querySelectorAll('.image-modal');
    imageModals.forEach(modal => {
      if (modal.classList.contains('active') && modal !== this.imageModal) {
        modal.classList.remove('active');
      }
    });
  }

  openModal() {
    this.closeImageModals();
    this.imageModal.classList.add('active');
  }

  closeModal() {
    this.imageModal.classList.remove('active');
  }
}

customElements.define('birthstone-picker', BirthstonePicker);